import axios from 'axios'

export default class AxiosPlugin {
  constructor(baseConfig = {}) {
    this.config = baseConfig
    this.baseConfig = baseConfig
    this.service = null
  }

  addConfig(axiosConfig = {}) {
    this.config = {
      ...this.config,
      ...axiosConfig
    }
  }

  setConfig(axiosConfig = {}) {
    this.config = {
      ...axiosConfig
    }
  }
}

AxiosPlugin.install = function (Vue, options = {}) {
  const instance = new this()
  const service = axios.create(options)

  // Request interceptor
  service.interceptors.request.use((config) => {
    // Do something before request is sent
    const mergeConfig = { ...instance.config }
    for (const [key, val] of Object.entries(config)) {
      if (key === 'headers') {
        for (const [header, headerVal] of Object.entries(val)) {
          mergeConfig.headers[header] = headerVal
        }
      } else {
        mergeConfig[key] = val
      }
    }
    return mergeConfig
  }, (error) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      // console.log(error.response.data);
      // console.log(error.response.status);
      // console.log(error.response.headers);

      if (error.response.status === 401) {
        Vue.prototype.$auth.logout({ returnTo: `${window.location.origin}` })
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log('Request Error:', error.request)
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Request Error:', error.message)
    }
    console.log('Axios Config Error:', error.config)

    return Promise.reject(error)
  })


  // Response interceptor
  service.interceptors.response.use((response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  }, (error) => {
    // Logout if Unauthorized Or Token Expired
    if (error?.response?.status === 401) {
      Vue.prototype.$auth.logout({ returnTo: `${window.location.origin}` })
    }

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  })

  instance.service = service

  Vue.prototype.$axios = instance.service
  Vue.prototype.$axiosPlugin = instance
}



